import {DTCreativeNode} from 'common/src/modules/decisionTree/decisionTree.types';
import {CreativeTemplateFeature} from 'common/src/modules/creativeTemplates/creativeTemplates.types';
import {toAiLandingPageSource} from '../aiModels/cardDetailsAI.enums';
import {getBaseHeader} from './utils';

function getSupportedFeatureLabels(creative: {features?: string[]} | undefined): string[] {
  const features = creative?.features || [];
  const supportedFeatures: string[] = [];

  if (features.includes(CreativeTemplateFeature.Feed)) {
    supportedFeatures.push('products');
  }

  if (features.includes(CreativeTemplateFeature.Location)) {
    supportedFeatures.push('location/store');
  }

  if (features.includes(CreativeTemplateFeature.Content)) {
    supportedFeatures.push('content');
  }

  if (features.includes(CreativeTemplateFeature.Weather)) {
    supportedFeatures.push('weather');
  }

  return supportedFeatures;
}

export function creativeCardToText(card: DTCreativeNode, mode: 'short' | 'full'): string {
  const header = getBaseHeader(card);
  const creative = card.creative;
  const supportedFeatures = getSupportedFeatureLabels(creative);

  if (mode === 'short') {
    const creativeName = creative?.name ?? 'not specified';
    const creativeId = creative?.id ?? card.creativeId;
    const creativeIdLine = `Creative '${creativeName}' ID ${creativeId}`;
    const showsLine = supportedFeatures.length ? `Shows ${supportedFeatures.join(' and ')}` : '';
    const fallbackLine = card.isFallbackCreative
      ? 'This is a fallback creative, it should NEVER be connected to any other card'
      : '';

    return [header, creativeIdLine, showsLine, fallbackLine].filter(Boolean).join('\n');
  }

  const creativeName = creative?.name ?? 'not specified';
  const creativeId = creative?.id ?? card.creativeId;
  const creativeIdLine = `Creative '${creativeName}' ID ${creativeId}`;
  const showsLine = supportedFeatures.length ? `Shows ${supportedFeatures.join(' and ')}` : '';
  const landingPageLine = `Landing Page Source: ${toAiLandingPageSource(card.landingPageSource) ?? ''}`;
  const fallbackLine = card.isFallbackCreative
    ? 'This is a fallback creative, it should NEVER be connected to any other card'
    : '';

  return [header, creativeIdLine, showsLine, landingPageLine, fallbackLine]
    .filter(Boolean)
    .join('\n');
}
